import { StringHelper } from "../../../utilities/contracts/string-helper";
import { MemberItem } from "./member-item.model";

export class MemberM360Response {
  readonly memberRecords?: MemberItem[];
  readonly paginationToken?: string;

  constructor(options: Partial<MemberM360Response> = {}) {
    this.memberRecords = options.memberRecords;
    this.paginationToken = StringHelper.clean(options.paginationToken || "");
  }
}
